export const SET_MENU_CARD_COPY_TASKS = 'SET_MENU_CARD_COPY_TASKS'
export const SET_MENU_CARD_UPDATED_AT = 'SET_MENU_CARD_UPDATED_AT'
